import React, { Component } from 'react';
import logo from './logo.svg';
// import './App.css';
import PrimarySearch from './views/primary'
import SagaSearch, {SagaPage} from './views/saga'
import NordenSearch, {NordenPage} from './views/norden'

import './resources/stylesheets/base.css'
import './resources/stylesheets/skeleton.css'
import './resources/stylesheets/layout.css'
import './resources/fonts/fonts.css'
import './resources/fonts/font.css'
import './resources/stylesheets/font-awesome.min.css'
import './resources/stylesheets/selectize.default.css'
import './resources/stylesheets/jquery-ui.min.css'
import './resources/stylesheets/from-site/system.base.css'
import './resources/stylesheets/from-site/system.theme.css'
import './resources/stylesheets/from-site/pages.css'
import './resources/stylesheets/from-site/font.css'
import './resources/stylesheets/from-site/tam-basic.css'
import './resources/stylesheets/from-site/tam-layout.css'
import './resources/stylesheets/from-site/tam-navigation.css'
import './resources/stylesheets/from-site/layout-fixed.css'
import './resources/stylesheets/custom/tamarkiv.css'
import configuration from './config/config.js'
import {
    BrowserRouter as Router,
    Route,
    Link
} from 'react-router-dom'
import { Provider } from 'react-redux'
import { compose, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';

import tamSearch from './reducers'

let store;
if(configuration.isDevMode){
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    store = createStore(tamSearch, composeEnhancers(
        applyMiddleware(thunk)
    ));
}else{
    store = createStore(tamSearch, applyMiddleware(thunk));
}


class App extends Component {
    routes = [];
    constructor(props){
        super(props);
        this.generateRoutes();
    }

    /**
     * Generates routes for supporting different url scenarios.
     */
    generateRoutes() {
        let prefixes = ['/', '/share/tamsok/'];

        let pages = [{
            page: PrimarySearch,
            alias: ['index.html', 'primary']
        }, {
            page: SagaSearch,
            alias: ['index-saga.html', 'saga']
        }, {
            page: SagaPage,
            alias: ['index-saga-no-header.html', 'saga-no-header']
        },{
            page: NordenSearch,
            alias: ['index-norden.html', 'norden']
        },{
            page: NordenPage,
            alias: ['index-norden-no-header.html', 'norden-no-header']
        }];

        for (const page in pages) {
            for (const alias in pages[page].alias) {
                for (const prefix in prefixes) {
                    this.routes.push(<Route path={prefixes[prefix] + pages[page].alias[alias]}
                                            component={pages[page].page} key={Math.random()}/>);
                }
            }
        }

    }

    render() {
        return (
            <Provider store={store}>
                <Router>
                    <div>
                        {this.routes}
                    </div>
                </Router>
            </Provider>
        );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js